import { MembershipSpecialization } from '../models/membership.specialization.model';
import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { RoleService } from './role.service';

@Injectable({
  providedIn: 'root'
})
export class MembershipSpecializationService {

  model: MembershipSpecialization = null;
  modelSearch: MembershipSpecialization = null;

  list: MembershipSpecialization[];
  baseUrl: string;

  totalRecords: number;
  pageSize: number = 10;
  currentPage: number = 1;
  totalPages: number;
  pages: number[];

  membershipTypeID: number;

  constructor(private roleService: RoleService, private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.baseUrl = baseUrl;
  }

  post() {
    this.model.createdBy = this.roleService.getStaffID();
    this.model.membershipTypeID = this.membershipTypeID;
    return this.http.post(this.baseUrl + "api/MembershipSpecialization", this.model);
  }

  put() {
    this.model.modifiedBy = this.roleService.getStaffID();
    this.model.membershipTypeID = this.membershipTypeID;
    return this.http.put(this.baseUrl + "api/MembershipSpecialization/" + this.model.membershipSpecializationID, this.model);
  }

  push() {
    this.model.createdBy = this.roleService.getStaffID();
    this.model.membershipTypeID = this.membershipTypeID;
    return this.http.post(this.baseUrl + "api/MembershipSpecialization/Push", this.model);
  }

  updateStatus(status) {
    this.model.status = status;
    return this.http.put(this.baseUrl + "api/MembershipSpecialization/UpdateStatus/" + this.model.membershipSpecializationID, this.model);
  }

  delete(id) {
    return this.http.delete(this.baseUrl + "api/MembershipSpecialization/" + id);
  }

  archive(id) {
    return this.http.get(this.baseUrl + "api/MembershipSpecialization/Archive/" + id);
  }

  search() {
    let params = new HttpParams().set("page", this.currentPage.toString()).set("pageSize", this.pageSize.toString());

    params = params.set("membershipTypeID", this.membershipTypeID.toString());

    if (this.modelSearch.specializationName != null)
      params = params.set("specializationName", this.modelSearch.specializationName.toString());


    this.http.get(this.baseUrl + "api/MembershipSpecialization/Search", { params: params })
      .toPromise()
      .then(res => this.loadData(res));
  }

  loadData(res) {
    this.list = res.item1 as MembershipSpecialization[];
    this.paginate(res.item2);
  }

  paginate(totalRecords) {

    var pageSize = this.pageSize;
    var currentPage = this.currentPage;
    // calculate total pages
    var totalPages = Math.ceil(totalRecords / pageSize);

    var startPage, endPage;
    if (totalPages <= 10) {
      // less than 10 total pages so show all
      startPage = 1;
      endPage = totalPages;
    } else {
      // more than 10 total pages so calculate start and end pages
      if (currentPage <= 6) {
        startPage = 1;
        endPage = 10;
      } else if (currentPage + 4 >= totalPages) {
        startPage = totalPages - 9;
        endPage = totalPages;
      } else {
        startPage = currentPage - 5;
        endPage = currentPage + 4;
      }
    }

    // calculate start and end item indexes
    var startIndex = (currentPage - 1) * pageSize;
    var endIndex = Math.min(startIndex + pageSize - 1, totalRecords - 1);

    this.totalPages = totalPages;
    this.totalRecords = totalRecords;

    // create an array of pages to ng-repeat in the pager control
    this.pages = [];
    var i;
    for (i = startPage; i <= endPage; i++)
      this.pages.push(i);
  };
}
